export function clearIndexedDB(dbName: string): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		// Request to delete the database
		const deleteRequest: IDBOpenDBRequest = window.indexedDB.deleteDatabase(dbName);

		deleteRequest.onerror = () => {
			// Try to clear the database if deletion fails
			try {
				const openRequest: IDBOpenDBRequest = window.indexedDB.open(dbName);

				openRequest.onsuccess = function openRequestSuccessHandler(this: IDBOpenDBRequest) {
					const db: IDBDatabase = this.result;
					// Get all object store names
					const objectStoreNames: string[] = Array.from(db.objectStoreNames);

					const transaction: IDBTransaction = db.transaction(objectStoreNames, 'readwrite');

					// Clear each object store
					objectStoreNames.forEach((storeName: string) => {
						transaction.objectStore(storeName).clear();
					});

					transaction.oncomplete = () => {
						db.close();
						reject(new Error(`Failed to delete ${dbName}, but cleared all data`));
					};

					transaction.onerror = () => {
						db.close();
						reject(new Error(`Failed to delete or clear ${dbName}`));
					};
				};

				openRequest.onerror = () => {
					reject(new Error(`Failed to open ${dbName} for clearing`));
				};
			} catch (err) {
				reject(
					new Error(
						`Failed to delete or clear ${dbName}: ${err instanceof Error ? err.message : String(err)}`,
					),
				);
			}
		};

		deleteRequest.onsuccess = () => {
			resolve();
		};

		deleteRequest.onblocked = () => {
			// The database is blocked, probably because there are open connections
			reject(
				new Error(`Database ${dbName} deletion blocked - please close all other tabs/connections`),
			);
		};
	});
}
